import React, {Component} from 'react';

class Contact extends Component {
    render() {
        return (
            <div>
                <div className={"initialInput"}>
                    <label className="label">
                        Please contact the developer on telegram in order to use this bot.<br/><br/>
                        Telegram: <p><a style={{color: '#5e8ce8'}} href={"http://t.me/adamsnipes"}>@AdamSnipes</a></p><br/>
                        Please also make sure to join the official bot channel to keep up with bot updates<br/><br/>
                        Bot Channel on Telegram: <a style={{color: '#5e8ce8'}} href={"https://t.me/AdamsSniperBot"}>@AdamsSniperBot</a><br />
                        <br />
                        Click <a style={{color: '#5e8ce8'}}
                           href={"https://adamsnipes.io"}>Here</a>  To Go Back To The Homepage.
                    </label>
                </div>
            </div>
        )
    }
}

export default Contact;